import PhotoSwipeTheme from './components/photoswipe';
import MasonryGallery from './components/masonry-gallery';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		// Photoswipe
		setTimeout(() => {
			Array.from(document.querySelectorAll('.pswp-gallery-social')).map(el => new PhotoSwipeTheme(el));
		}, "2000");

		Array.from(document.querySelectorAll( '.gsap-animation' )).map(el => new Animates(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery-social')).map(el => new MasonryGallery(el));
	}
};

domLoaded(() => {
	App.init();
});
